import React, { Component } from 'react';
import { Accordion }        from 'react-bootstrap';

class Questions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading   : true,
      item      : this.props.item,
      questions : [],
    };
  }

  componentDidMount() {
    if (this.props.item) {
      var questions  = [];
      for (var i = 0; i < this.props.item.length; i++) {
        var question = this.props.item[i];
        questions.push({ question: question.question, answer: question.answer });
      }

      this.setState({ questions: questions, loading: false });
    }
  }

  render() { 
    var questions = [];
    if (this.state.questions.length > 0) {
      for (var i = 0; i < this.state.questions.length; i++) {
        var question = this.state.questions[i];
        questions.push(
          <Accordion key={i}>
            <p>
              <b>Question:</b> <span className='word-right'>{question.question}</span>
            </p>
            <p>
              <b>Answer:</b> <span className='word-right'>{question.answer}</span>
            </p>
          </Accordion>
        );
      }
    }

    let well = null;
    if (questions.length === 0) {
      well = 
        <Accordion key={this.state.key}>
          <b>No Questions from Ticket</b>
        </Accordion>;
    }
    else {
      well =
          <Accordion style={{marginBottom: '20px'}}>
          <Accordion.Heading>
            <Accordion.Title toggle>Questions</Accordion.Title>
          </Accordion.Heading>
          <Accordion.Body collapsible>
            {questions}
          </Accordion.Body>
        </Accordion>;
    }

    return (
      <div>
        {well}
      </div>
    );
  }
}

export default Questions;
